module.exports = __webpack_public_path__ + "static/media/39import-74.463b7cfb.xlsx";